import { useAuthStore } from '../lib/auth';
import { Card, CardContent } from '../components/ui/card';
import { Database, Shield } from 'lucide-react';
import ManualBackup from './backup/ManualBackup';
import ScheduledBackup from './backup/ScheduledBackup';
import DeletedRecords from './backup/DeletedRecords';

export default function DatabaseBackup() {
  const { user } = useAuthStore();

  if (user?.role !== 'SUPER_ADMIN') {
    return (
      <div className="flex items-center justify-center h-96">
        <Card className="max-w-md">
          <CardContent className="pt-6 text-center">
            <Shield className="h-12 w-12 mx-auto text-red-500 mb-4" />
            <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">Erisim Engellendi</h2>
            <p className="text-slate-500 dark:text-slate-400">Bu sayfaya sadece Super Admin erisebilir.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="database-backup-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <Database className="h-7 w-7 text-blue-600" />
          Veritabani Yedekleme
        </h1>
        <p className="text-slate-500 dark:text-slate-400 mt-1">
          MongoDB veritabaninizin tam yedegini alin veya geri yukleyin
        </p>
      </div>

      <ManualBackup />
      <ScheduledBackup />
      <DeletedRecords />
    </div>
  );
}
